import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10562b74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-ct light flex-bwn rel" }
const _hoisted_2 = ["onClick"]

import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { changeB2C } from '@/apis/login'
import { bury } from '@/util/useBury'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()

const Plats = [
  { label: 'B2B', path: '/', name: 'b2b' },
  { label: 'D2C', path: '/', name: 'd2c' }
]

const plat = computed(() => {
  return store.getters.plat
})

let loading = false
const change = async (v: any) => {
  if (loading) return
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: v.name
    }
  })
  bury('ALL_Click_ModeChose')
  if (v.name !== plat.value) {
    if (store.getters.token) {
      loading = true
      changeB2C().then((res) => {
        store.dispatch('route/refreshToken', res.data.token)
      })
    } else {
      store.commit('route/plat', v.name)
      localStorage.setItem('_reload_page_', Math.random().toString().slice(2))
      location.reload()
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_main = _resolveDirective("main")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(Plats, (v) => {
      return _createElementVNode("span", {
        onClick: ($event: any) => (change(v)),
        key: v.name,
        class: _normalizeClass(["btn", { active: v.name === _unref(plat) }])
      }, _toDisplayString(v.label), 11, _hoisted_2)
    }), 64))
  ], 512)), [
    [_directive_main]
  ])
}
}

})